import { lazy } from "react";
const MatchesComponent = lazy(
  () => import("./matchesComponent/MatchesComponent")
);
const TeamsComponent = lazy(() => import("./teamsComponent/TeamsComponent"));
const LeaguesComponent = lazy(
  () => import("./leaguesComponent/LeaguesComponent")
);
const PlayersComponent = lazy(
  () => import("./playersComponent/PlayersComponent")
);
const Components = {
  Matches: MatchesComponent,
  Teams: TeamsComponent,
  Leagues: LeaguesComponent,
  Players: PlayersComponent
};
export {
  Components
};
